import React from 'react';
import styles from './styles.module.scss';

const Layout = ({ children }) => (
  <div className={styles.container}>
    <div className={styles.content}>{children}</div>
  </div>
);

export default Layout;
